import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ErrorPageType } from 'src/app/helpers/enum/error-page-type.enum';
import { DashboardService } from 'src/app/services/dashboard/dashboard.service';
import { SqliteStorageService } from 'src/app/services/sqlite-storage/sqlite-storage.service';
import { UserProvider } from 'src/app/services/providers/user-provider.ts/user-provider';
import { resolveDriverData } from './resolve-driver-data';

export const vehicleAssignedGuard: CanActivateFn = async () => {
  const dashboardService = inject(DashboardService);
  const sqliteStorageService = inject(SqliteStorageService);
  const userProvider = inject(UserProvider);
  const router = inject(Router);

  const driverData = await resolveDriverData({ dashboardService, sqliteStorageService, userProvider });

  if (driverData?.vehicles?.length) {
    return true;
  }

  if (driverData) {
    return router.createUrlTree(['/not-assign-to-vehicle'], {
      queryParams: { reason: 'noVehicleAssigned' },
    });
  }

  return router.createUrlTree(['/error'], {
    queryParams: { type: ErrorPageType.NETWORK_ERROR },
  });
};
